<!-- ec top banner -->
@if (outletBanners['main_promotional_card']?.length) {
    <img
        class="promotional-banner"
        role="button"
        tabindex="0"
        src="https://assets.box8.co.in/missing/eatclub.png"
        [imageSrc]="outletBanners['main_promotional_card'][0].image"
        appDeferImageLoad
        alt="banner"
        (click)="openActionLink(outletBanners['main_promotional_card'][0], 0)" />
}

<!-- mojo/box8 top banner -->
@if (outletBanners['main_banners']?.length) {
    <app-image-slider
        [images]="outletBanners['main_banners']"
        [showIndicators]="true"
        [wrapperClass]="'main-banner-carousel'"
        [infiniteScroll]="true"
        [mainBanner]="true">
    </app-image-slider>
}

<div class="container home-page-banners">
    <!-- top offers today banner -->
    @if (outletBanners['icon_banners']?.length) {
        <div class="top-offers-wrapper">
            <app-gradient-heading [text]="'Top offers today'" />
            <app-scroll-wrapper [classes]="['banner-container', 'offer-banner']" [enableScrollListener]="!isMobile">
                @for (banner of outletBanners['icon_banners']; let i = $index; track banner) {
                    <img
                        scroll-item
                        role="button"
                        tabindex="0"
                        alt="offer-banner"
                        [imageSrc]="banner.image"
                        appDeferImageLoad
                        (click)="openActionLink(banner, i)" />
                }
            </app-scroll-wrapper>
        </div>
    }

    <!-- sub banners present in mojopizza eg: ratings, refer, etc -->
    @if (outletBanners['landing_feature']?.length && isMobile) {
        <div class="banner-container landing-feature-wrapper">
            @for (banner of outletBanners['landing_feature']; let i = $index; track banner) {
                <img
                    role="button"
                    tabindex="0"
                    [imageSrc]="banner.image"
                    appDeferImageLoad
                    class="landing-feature"
                    (click)="openActionLink(banner, i)"
                    alt="banner" />
            }
        </div>
    }
    <!-- sub banners eg:. umbrella, refer, etc -->
    @if (outletBanners['promotional_leaderboard']?.length && isMobile) {
        <div class="banner-container promotional-leaderboard-wrapper">
            @for (banner of outletBanners['promotional_leaderboard']; let i = $index; track banner) {
                <img
                    role="button"
                    tabindex="0"
                    [imageSrc]="banner.image"
                    appDeferImageLoad
                    class="promotional-leaderboard"
                    (click)="openActionLink(banner, i)"
                    alt="banner" />
            }
        </div>
    }

    <!-- what's on your mind banner -->
    @if (outletBanners['landing_woym_grid']?.length) {
        <div class="whats-on-mind-wrapper">
            <app-gradient-heading [text]="'What’s on your mind?'" />
            <whats-on-your-mind-banner
                [isMobile]="isMobile"
                [banners]="outletBanners['landing_woym_grid']"
                (openActionLink)="openActionLink($event.banner, $event.index)" />
        </div>
    }
</div>
